import { SubscriptionsUsageStoreState } from '../../types';

export interface SubscriptionsUsageMainStoreState {
	subscriptionsUsage: SubscriptionsUsageStoreState;
}

export interface SubscriptionWithExpiry {
	expiry: string;
	name: string;
}
